import { useMutation, useQueryClient } from "react-query";
import yearPlanAPI from "../../../api/yearPlanAPI";

export const useSaveSubjectPlanInYearPlan = () => {
  const queryClient = useQueryClient();

  return useMutation(yearPlanAPI.updateSubjectPlanInYearPlan, {
    onSuccess: () => queryClient.invalidateQueries("yearPlans"),
    onError: (error) => console.log("Saving error: ", error),
  });
};
